var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?_c('div',{staticClass:"box",style:(_vm.style),on:{"click":function($event){return _vm.$emit("click")}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }